import { Routes, Route } from "react-router-dom";

import LandingPage from "./LandingPage";
import TableSelection from "./TableSelection";
import MenuPage from "./MenuPage";
import OrderSuccess from "./OrderSuccess";

const PublicRoutes = () => {
  return (
    // <Routes>
    //   <Route index element={<LandingPage />} />
    //   <Route path="tables" element={<TableSelection />} />
    //   <Route path="menu" element={<MenuPage />} />
    //   <Route path="success" element={<OrderSuccess />} />
    //   <Route path="*" element={<LandingPage />} />
    // </Routes>
    <Routes>
  <Route index element={<LandingPage />} />
  <Route path="tables" element={<TableSelection />} />
  <Route path="menu" element={<MenuPage />} />
  <Route path="success" element={<OrderSuccess />} />
</Routes>

  );
};


export default PublicRoutes;
